import React, { useContext, useCallback, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { history } from '../../history';
import { UserContext } from '../../context';
import { FiLogOut, FiMenu } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles.css';

const Menu = memo(({ onSidebarToggle }) => {
  const context   = useContext(UserContext);
  const logado    = context.isLogger;
  const userRole  = localStorage.getItem('user-role');
  const userName  = localStorage.getItem('user-name') || '';
  const isMaster  = userRole === 'MASTER';
  const location  = useLocation();

  const logout = useCallback(() => {
    localStorage.removeItem('delphireact-token');
    localStorage.removeItem('user-role');
    localStorage.removeItem('user-name');
    context.alterLogin(false);
    history.push('/login');
  }, [context]);

  if (!logado) return null;

  const initials = userName
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase() || 'U';

  const links = [
    { to: '/',           label: 'Home' },
    { to: '/pdv',        label: 'PDV' },
    { to: '/lics',       label: 'Licenças' },
    { to: '/ver',        label: 'Versões' },
    { to: '/csapi',      label: 'Produtos AZ' },
    ...(isMaster ? [
      { to: '/auditoria',     label: 'Auditar' },
      { to: '/update',        label: 'Update' },
      { to: '/classificacao', label: 'Classificação' },
    ] : []),
  ];

  return (
    <nav className="cs-navbar">
      {/* Hamburger — aparece só no mobile */}
      <button className="cs-hamburger" onClick={onSidebarToggle} title="Menu">
        <FiMenu size={20} />
      </button>

      {/* Brand */}
      <a className="cs-navbar-brand" href="/">
        <div className="cs-logo-icon">C</div>
        <div>
          Compsoft
          <span className="cs-sub">Sistemas e Automação</span>
        </div>
      </a>

      <div className="cs-nav-divider cs-nav-divider-after-brand" />

      {/* Links de navegação — ocultos no mobile */}
      <ul className="cs-nav-links">
        {links.map(({ to, label }) => (
          <li key={to}>
            <Link
              className={`cs-link ${location.pathname === to ? 'active' : ''}`}
              to={to}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>

      <div className="cs-nav-divider" />

      {/* Usuário + Sair */}
      <div className="cs-user-badge">
        <div className="cs-avatar">{initials}</div>
        <span className="cs-uname">{userName || 'Usuário'}</span>
      </div>

      <button
        className="cs-logout-btn ms-2"
        onClick={logout}
        title="Sair da aplicação"
      >
        <FiLogOut size={16} />
        <span className="cs-logout-label">Sair</span>
      </button>
    </nav>
  );
});

export default Menu;
